<template>
    <div class="form-container">
        <h2>Edit Vitals</h2>
        <hr />

        <form @submit.prevent="submitForm">
            <div class="row">
                <div class="col-md-6 mb-2">
                    <label>Pulse</label>
                    <input type="text" v-model="form.pulse" class="form-control" />
                    <div v-if="errors.pulse" class="text-danger small">{{ errors.pulse[0] }}</div>
                </div>

                <div class="col-md-6 mb-2">
                    <label>Respiration</label>
                    <input type="text" v-model="form.respiration" class="form-control" />
                    <div v-if="errors.respiration" class="text-danger small">{{ errors.respiration[0] }}</div>
                </div>

                <div class="col-md-6 mb-2">
                    <label>Temperature</label>
                    <input type="text" v-model="form.temperature" class="form-control" />
                    <div v-if="errors.temperature" class="text-danger small">{{ errors.temperature[0] }}</div>
                </div>

                <div class="col-md-6 mb-2">
                    <label>Blood Pressure</label>
                    <input type="text" v-model="form.blood_pressure" class="form-control" />
                    <div v-if="errors.blood_pressure" class="text-danger small">{{ errors.blood_pressure[0] }}</div>
                </div>

                <div class="col-md-6 mb-2">
                    <label>Oxygen</label>
                    <input type="text" v-model="form.oxygen" class="form-control" />
                    <div v-if="errors.oxygen" class="text-danger small">{{ errors.oxygen[0] }}</div>
                </div>
            </div>

            <button type="submit" class="btn btn-success mt-3">💾 Save</button>
        </form>
    </div>
</template>

<script>
export default {
    name: 'IOPMedicalVitals',
    props: ['iop_medical_print_id'],
    data() {
        return {
            form: {
                iop_medical_print_id: this.iop_medical_print_id,
                pulse: '',
                respiration: '',
                temperature: '',
                blood_pressure: '',
                oxygen: ''
            },
            errors: {}
        };
    },
    mounted() {
        this.loadForm();
    },
    methods: {
        async loadForm() {
            try {
                const res = await this.$api.get(`/iop-vitals/${this.iop_medical_print_id}`);
                if (res.data && Object.keys(res.data).length > 0) {
                    this.form = { ...this.form, ...res.data };
                }
            } catch (err) {
                // ignore
            }
        },

        async submitForm() {
            this.errors = {};
            try {
                await this.$api.post(`/iop-vitals`, this.form);
                this.$router.back();
            } catch (err) {
                if (err.response?.data?.errors) {
                    this.errors = err.response.data.errors;
                } else {
                    alert('Failed to save Vitals');
                }
            }
        }
    }
};
</script>

<style scoped>
label {
    font-weight: 500;
}
</style>